<ng-container *ngIf="dashboardService.sideBarState$ | async as sidebar">
    <ul
        *ngIf="
            currentOrganisation != null &&
            currentOrganisation.type === 'organisation_loaded'
        "
        class="nav flex-column"
    >
        <li class="nav-item nav-heading">
            <ul class="nav">
                <li class="nav-item" *ngIf="visibleSections.onboardingTasks">
                    <span class="nav-link widgets-control">
                        <div>
                            <span class="fa-clipboard-list fa nav-icon"></span>
                            <span
                                class="fa-clipboard-list fa nav-icon active"
                            ></span>
                            <span
                                class="name"
                                (click)="scrollTo('onboardingTasksSection')"
                                >Onboarding Tasks
                            </span>
                        </div>
                        <div class="d-flex vertical-align">
                            <mat-slide-toggle
                                [(ngModel)]="selectedWidgets.onboardingTasks"
                                (change)="onMenuChanged()"
                            >
                            </mat-slide-toggle>
                        </div>
                    </span>
                </li>
                <li class="nav-item" *ngIf="visibleSections.generalTasks">
                    <span class="nav-link widgets-control">
                        <div>
                            <span class="fa-list-check fa nav-icon"></span>
                            <span
                                class="fa-list-check fa nav-icon active"
                            ></span>
                            <span
                                class="name"
                                (click)="scrollTo('generalTasksSection')"
                                >General Tasks
                            </span>
                        </div>
                        <div class="d-flex vertical-align">
                            <mat-slide-toggle
                                [(ngModel)]="selectedWidgets.generalTasks"
                                (change)="onMenuChanged()"
                            >
                            </mat-slide-toggle>
                        </div>
                    </span>
                </li>
                <li class="nav-item" *ngIf="visibleSections.profile">
                    <span class="nav-link widgets-control">
                        <div>
                            <span class="fa-user fa nav-icon"></span>
                            <span class="fa-user fa nav-icon active"></span>
                            <span
                                class="name"
                                (click)="scrollTo('profileSection')"
                                >Profile
                            </span>
                        </div>
                        <div class="d-flex vertical-align">
                            <mat-slide-toggle
                                [(ngModel)]="selectedWidgets.profile"
                                (change)="onMenuChanged()"
                            >
                            </mat-slide-toggle>
                        </div>
                    </span>
                </li>
                <li class="nav-item" *ngIf="visibleSections.operations">
                    <span class="nav-link widgets-control">
                        <div>
                            <span
                                class="fa-industry-windows fa nav-icon"
                            ></span>
                            <span
                                class="fa-industry-windows fa nav-icon active"
                            ></span>
                            <span
                                class="name"
                                (click)="scrollTo('operationsSection')"
                                >Operations
                            </span>
                        </div>
                        <div class="d-flex vertical-align">
                            <mat-slide-toggle
                                [(ngModel)]="selectedWidgets.operations"
                                (change)="onMenuChanged()"
                            >
                            </mat-slide-toggle>
                        </div>
                    </span>
                </li>
                <li class="nav-item" *ngIf="visibleSections.resources">
                    <span class="nav-link widgets-control">
                        <div>
                            <span class="fa-drone fa nav-icon"></span>
                            <span class="fa-drone fa nav-icon active"></span>
                            <span
                                class="name"
                                (click)="scrollTo('resourcesSection')"
                                >Resources
                            </span>
                        </div>
                        <div class="d-flex vertical-align">
                            <mat-slide-toggle
                                [(ngModel)]="selectedWidgets.resources"
                                (change)="onMenuChanged()"
                            >
                            </mat-slide-toggle>
                        </div>
                    </span>
                </li>
                <li class="nav-item" *ngIf="visibleSections.organisation">
                    <span class="nav-link widgets-control">
                        <div>
                            <span class="fa-buildings fa nav-icon"></span>
                            <span
                                class="fa-buildings fa nav-icon active"
                            ></span>
                            <span
                                class="name"
                                (click)="scrollTo('organisationSection')"
                                >Organisation
                            </span>
                        </div>
                        <div class="d-flex vertical-align">
                            <mat-slide-toggle
                                [(ngModel)]="selectedWidgets.organisation"
                                (change)="onMenuChanged()"
                            >
                            </mat-slide-toggle>
                        </div>
                    </span>
                </li>
            </ul>
        </li>
    </ul>
</ng-container>
